import { Timestamp, Token, User } from '../@types'
import { Shop, ShopPlanSubscription } from '../@types/shop'

import instance from './instance'


export type Me = Timestamp &
User & {
  Shop?: Shop & {
    ShopPlanSubscription?: ShopPlanSubscription
  }
}

export const fetchMe = async () => {
  const response = await instance.get<Me>('/users/me')
  return response.data
}

export type LoginInfo = {
  userAccount?: string
  userPW?: string
}

export const login = async (payload: LoginInfo) => {
  const response = await instance.post<Token>('/users/login', payload)
  return response.data
}
